import { Link } from 'react-router-dom';
import { featureGuides } from '@/mocks/siteData';

const featureImages: Record<string, string> = {
  'feature-what-is': 'https://readdy.ai/api/search-image?query=Clean%20modern%20home%20office%20with%20large%20iMac%20displaying%20colorful%20spreadsheet%20data%20charts%2C%20ceramic%20coffee%20mug%20beside%20keyboard%2C%20trailing%20ivy%20plant%20on%20white%20shelf%2C%20warm%20morning%20sunlight%20through%20sheer%20curtains%2C%20Scandinavian%20interior%20with%20oak%20desk%2C%20bright%20airy%20atmosphere&width=800&height=600&seq=fg-what-is-v2&orientation=landscape',
  'feature-how-to': 'https://readdy.ai/api/search-image?query=Comfortable%20workspace%20with%20iPad%20Pro%20displaying%20shopping%20app%20interface%20beside%20open%20notebook%20with%20handwritten%20checklist%2C%20aromatic%20tea%20in%20glass%20cup%2C%20warm%20afternoon%20light%20casting%20soft%20shadows%2C%20minimalist%20desk%20setup%20with%20bamboo%20accessories%2C%20calm%20focused%20atmosphere&width=800&height=600&seq=fg-how-to-v2&orientation=landscape',
  'feature-vs': 'https://readdy.ai/api/search-image?query=Creative%20split%20composition%20with%20two%20laptops%20side%20by%20side%20on%20wide%20wooden%20table%2C%20left%20screen%20showing%20organized%20spreadsheet%20view%2C%20right%20screen%20showing%20chaotic%20browser%20tabs%2C%20small%20cactus%20in%20terracotta%20pot%20between%20them%2C%20bright%20even%20daylight%2C%20conceptual%20productivity%20photography&width=800&height=600&seq=fg-vs-v2&orientation=landscape',
};

export default function FeatureGrid() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 text-center mb-12 md:mb-16">
          Mulebuy Spreadsheet SEO Guides
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {featureGuides.map((guide) => (
            <Link
              key={guide.seq}
              to={guide.slug}
              className="group relative rounded-xl overflow-hidden aspect-[4/3] cursor-pointer"
            >
              <img
                src={featureImages[guide.seq]}
                alt={guide.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                title={guide.title}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/25 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
                <h3 className="text-lg md:text-xl font-heading font-semibold text-white mb-2 leading-snug">
                  {guide.title}
                </h3>
                <span className="text-sm text-white/80 group-hover:text-white transition-colors underline underline-offset-4">
                  {guide.subtitle}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}